<template>
  <v-card
      color="#fff"
      class="post_card mx-2 mx-sm-3 mb-6 mb-sm-12"
      elevation="0"
      :max-width="'100%'"
  >
    <div class="post_logo">
      <img :src="post.display_thumb_url" alt="photo"/>
    </div>
    <div class="post_info">
      <div class="post_comments d-flex">
        <img class="mr-3" src="../assets/like_dark.svg" alt="likes"/>
        <span class="mt-2">{{ post.likes_count }}</span>
      </div>
      <div class="post_comments d-flex">
        <img class="mr-3" src="../assets/comment_dark.svg" alt="likes"/>
        <span class="mt-2">{{ post.comments_count }}</span>
      </div>
    </div>
    <div v-if="post.title" class="post_title text-center py-6">
      {{ post.title }}
    </div>
    <div v-else style="margin-bottom:29px"></div>
    <div class="post_btn text-center pb-6">
      <v-btn
          :disabled="status === 'suspend'"
          color="#76CD68"
          height="50"
          class="buy_btn mb-2 px-4 order_followers"
          dark
          rounded
          depressed
          @click="() => buy_more = true"
      >
          Get Likes/Comments
      </v-btn>
    </div>

    <v-expand-transition>
      <div
          v-if="buy_more"
          class="transition-fast-in-fast-out transition_card"
      >
        <div v-if="post.title" class="post_title text-center my-6">
          {{ post.title }}
        </div>
        <div v-else style="margin-bottom:29px"></div>
        <div class="mx-6">
          <div class="scroller d-flex ml-auto mr-auto align-center mt-6 mt-lg-0">
            <v-slider
                thumb-color="#2C4370"
                thumb-size="23px"
                tick-size="10"
                :loader-height="10"
                hide-details=""
                v-model="order_likes"
                track-color="#EEF4FF"
                track-fill-color="#ACBFE3"
                :max="scores.likes >= scores.minLikes ? scores.likes : 0"
                :min="scores.likes < scores.minLikes ? scores.likes : scores.minLikes"
            >
              <template v-slot:prepend>
                <v-icon
                    @click="decrementLikes"
                >
                  mdi-minus
                </v-icon>
              </template>

              <template v-slot:append>
                <v-icon
                    @click="incrementLikes"
                >
                  mdi-plus
                </v-icon>
              </template>
            </v-slider>
          </div>
        </div>
        <div class="d-flex mx-8 my-4 justify-space-between">
          <div class="post_comments d-flex align-center" style="margin-right: 7px">
            <img class="mr-2" src="../assets/like_dark.svg" alt="likes"/>
            <v-text-field
                v-if="scores.likes >= scores.minLikes"
                ref="likesInput"
                type="number"
                class="v-text-input"
                v-model="order_likes"
                :min="scores.likes < scores.minLikes ? scores.likes : scores.minLikes"
                :max="scores.likes >= scores.minLikes ? scores.likes : 0"
                :step="1"
                @blur="validateLikes"
                @click="likes_ordered=false"
            ></v-text-field>
            <v-text-field
                v-else
                ref="followersInput"
                class="v-text-input"
                style="max-width: 110px"
                v-model="textNoLikes"
                disabled
                :hint="scores.likes < scores.minLikes ? 'min ' + scores.minLikes : ''"
                persistent-hint
            >
            </v-text-field>
            <!--                        <span class="mt-2">{{post.likes_count + order_likes }}</span>-->
          </div>
          <template v-if="scores.likes >= scores.minLikes">
            <template v-if="!likes_ordered_success">
              <v-btn
                  v-if="order_likes && !likes_ordered"
                  :color="!likes_ordered ? '#2C4370' : '#76CD68'"
                  width="107px"
                  height="50"
                  class="buy_btn"
                  :outlined="!likes_ordered"
                  :dark="likes_ordered"
                  rounded
                  @click="() => { likes_ordered = true }"
              >
                {{ 'Order' }}
              </v-btn>
              <template v-if="likes_ordered">
                <v-btn
                    v-if="order_likes"
                    :color="!likes_ordered ? '#2C4370' : '#76CD68'"
                    height="50"
                    class=""
                    :outlined="!likes_ordered"
                    :dark="likes_ordered"
                    rounded
                    @click="() => { handleOrder('likes') }"
                >
                  <v-icon
                      dark
                  >
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-btn>

                <v-btn
                    v-if="order_likes"
                    color="#9F4343"
                    width="50px"
                    height="50px"
                    class="mx-2"
                    outlined
                    rounded
                    @click="() => {likes_ordered = false}"
                >
                  <v-icon
                      dark
                  >
                    mdi-cancel
                  </v-icon>
                </v-btn>
              </template>
            </template>
            <template v-else>
              <v-btn
                  color="#81EF7F"
                  width="107px"
                  height="50"
                  class="buy_btn"
                  outlined
                  rounded
                  @click="() => {likes_ordered_success = false}"
              >
                <img src="../assets/ok_green.svg" alt="ok"/>
              </v-btn>
            </template>
          </template>
          <template v-else>
            <ModalSelectFollowers
                v-bind:slug="'instagram'"
                v-bind:typeProduct="'likes'"
                v-bind:singleData="singleData"
            />
          </template>

        </div>
        <div class="mx-6">
          <div class="scroller d-flex ml-auto mr-auto align-center mt-6 mt-lg-0">
            <v-slider
                thumb-color="#2C4370"
                thumb-size="23px"
                tick-size="1"
                :loader-height="10"
                hide-details=""
                v-model="order_comments"
                track-color="#EEF4FF"
                track-fill-color="#ACBFE3"
                :max="scores.comments >= scores.minComments ? scores.comments : 0"
                :min="scores.comments < scores.minComments ? scores.comments : scores.minComments"
            >
              <template v-slot:prepend>
                <v-icon
                    @click="decrementComments"
                >
                  mdi-minus
                </v-icon>
              </template>
              <template v-slot:append>
                <v-icon
                    @click="incrementComments"
                >
                  mdi-plus
                </v-icon>
              </template>
            </v-slider>
          </div>
        </div>
        <div class="d-flex mx-8 my-4 justify-space-between">
          <div class="post_comments d-flex align-center" style="margin-right: 7px">
            <img class="mr-2" src="../assets/comment_dark.svg" alt="likes"/>
            <v-text-field
                v-if="scores.comments >= scores.minComments"
                ref="commentsInput"
                type="number"
                class="v-text-input"
                v-model="order_comments"
                :max="scores.comments >= scores.minComments ? scores.comments : 0"
                :min="scores.comments < scores.minComments ? 0 : scores.minComments"
                :step="1"
                @blur="validateComments"
                @click="comments_ordered=false"
            ></v-text-field>
            <v-text-field
                v-else
                ref="followersInput"
                class="v-text-input"
                style="max-width: 110px"
                v-model="textNoComments"
                disabled
                :hint="scores.comments < scores.minComments ? 'min ' + scores.minComments : ''"
                persistent-hint
            >
            </v-text-field>
            <!--                        <span class="mt-2">{{post.comments_count + order_comments }}</span>-->
          </div>
          <template v-if="scores.comments >= scores.minComments">
            <template v-if="!comments_ordered_success">
              <v-btn
                  v-if="order_comments && !comments_ordered"
                  :color="!comments_ordered ? '#2C4370' : '#76CD68'"
                  width="107px"
                  height="50"
                  class="buy_btn"
                  :outlined="!comments_ordered"
                  :dark="comments_ordered"
                  rounded
                  @click="() => { comments_ordered = true }"
              >
                {{ 'Order' }}
              </v-btn>
              <template v-if="comments_ordered">
                <v-btn
                    v-if="order_comments"
                    :color="!comments_ordered ? '#2C4370' : '#76CD68'"
                    height="50"
                    :outlined="!comments_ordered"
                    :dark="comments_ordered"
                    rounded
                    @click="() => { handleOrder('comments') }"
                >
                  <v-icon
                      dark
                  >
                    mdi-checkbox-marked-circle
                  </v-icon>
                </v-btn>
                <v-btn
                    v-if="comments_ordered"
                    color="#9F4343"
                    width="50px"
                    height="50px"
                    class="mx-2"
                    outlined
                    rounded
                    @click="() => { comments_ordered = false }"
                >
                  <v-icon
                      dark
                  >
                    mdi-cancel
                  </v-icon>
                </v-btn>
              </template>

            </template>

            <template v-else>
              <v-btn
                  color="#81EF7F"
                  width="107px"
                  height="50"
                  class="buy_btn"
                  outlined
                  rounded
                  @click="() => {comments_ordered_success = false}"
              >
                <img src="../assets/ok_green.svg" alt="ok"/>
              </v-btn>
            </template>
          </template>
          <template v-else>
            <ModalSelectFollowers
                v-bind:slug="'instagram'"
                v-bind:typeProduct="'comments'"
                v-bind:singleData="singleData"
            />
          </template>
        </div>
        <div class="mt-6 text-center mb-6">
          <v-btn
              color="#2C4370"
              width="137px"
              height="50"
              class="mb-2"
              outlined
              rounded
              @click="() => buy_more = false"
          >
            Close
          </v-btn>
        </div>
      </div>
    </v-expand-transition>
    <v-slide-y-transition>
      <div
          v-if="buy_more"
          class="transition-fast-in-fast-out top_transition"
      >
        <div class="post_info">
          <div class="post_comments d-flex">
            <img class="mr-3" src="../assets/like_dark.svg" alt="likes"/>
            <span class="mt-2">{{ post.likes_count }}</span>
          </div>
          <div class="post_comments d-flex">
            <img class="mr-3" src="../assets/comment_dark.svg" alt="likes"/>
            <span class="mt-2">{{ post.comments_count }}</span>
          </div>
        </div>
      </div>
    </v-slide-y-transition>
  </v-card>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import vue from 'vue'
import { updateCounts } from '../utils/utils'
import ModalSelectFollowers from '../components/ModalSelectFollowers'

export default {
  name: 'InstagramPostCard',
  props: ['post', 'scores', 'singleData'],
  components: { ModalSelectFollowers },
  data: function () {
    return {
      textNoLikes: this.scores.likes,
      textNoComments: this.scores.comments,
      buy_more: false,
      order_likes_processing: false,
      order_likes: 0,
      likes_ordered: false,
      likes_ordered_success: false,
      order_comments_processing: false,
      order_comments: 0,
      comments_ordered: false,
      comments_ordered_success: false
    }
  },
  computed: {
    ...mapGetters("user", ["status"]),
  },
  methods: {
    ...mapActions('order', ['createNewOrder']),
    ...mapActions('scores', ['getInstagramStatistic']),
    handleOrder (type) {
      if (this[`order_${type}`] < 1) {
        return
      }
      if (this[`order_${type}_processing`]) {
        return
      }
      this[`order_${type}_processing`] = true
      this.createNewOrder({
        id: this.post.id,
        serviceId: type === 'likes' ? 1 : 2,
        quantity: this[`order_${type}`],
      }).then((data) => {
        console.log(data)
        this[`order_${type}`] = 0
        this[`${type}_ordered`] = false
        this[`order_${type}_processing`] = false
        this[`${type}_ordered_success`] = true
        this.getInstagramStatistic()
      }).catch(() => {
        this[`${type}_ordered`] = false
        this[`order_${type}_processing`] = false
      })
    },
    decrementComments () {
      this.order_comments--
    },
    incrementComments () {
      this.order_comments++
    },
    decrementLikes () {
      this.order_likes--
    },
    incrementLikes () {
      this.order_likes++
    },
    validateComments (event) {
      const count = updateCounts(event, this.scores.minComments, this.scores.comments)
      this.$refs.commentsInput.lazyValue = count
      this.$refs.commentsInput.initialValue = count
      vue.set(this, 'order_comments', count)
      event.target.value = count
    },
    validateLikes (event) {
      const count = updateCounts(event, this.scores.minLikes, this.scores.likes)
      this.$refs.likesInput.lazyValue = count
      this.$refs.likesInput.initialValue = count
      console.log(count)
      vue.set(this, 'order_likes', count)
      event.target.value = count
    },
  },
}
</script>
<style scoped>
.transition-fast-in-fast-out.top_transition {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1) !important;
}

.v-input {
  min-width: 68px !important;
  margin-left: 5px;
}
.opacity-bg {
    background: #fff;
}

.post_logo img {
    height: 550px;
    width: 100%;
    object-fit: cover;
}
</style>
